import { useState } from "react";
import { Table } from "antd";
import { useQuery } from "react-query";
import { useNavigate } from "react-router";
import { getCampaigns } from "../../api/campaign";
import { usePermissionEffect } from "../../utils/usePermissionEffect";
import { AUDIENCE_LABELS, CampaignStatus } from "./shared";

const columns = [
  {
    title: "Subject",
    dataIndex: "subject",
    key: "subject",
    render: (v) => <p className="font-bold">{v}</p>,
  },
  {
    title: "Audience",
    dataIndex: "audience",
    key: "audience",
    render: (v) => AUDIENCE_LABELS[v] || v,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (v) => <CampaignStatus status={v} />,
  },
  {
    title: "Delivered",
    key: "stats",
    render: (_, r) =>
      r.status === "draft"
        ? "—"
        : `${Number(r.stats?.sent || 0).toLocaleString()}${
            r.stats?.failed ? ` (${r.stats.failed} failed)` : ""
          }`,
  },
  {
    title: "Date",
    key: "date",
    render: (_, r) => (
      <p className="whitespace-nowrap">
        {r.sentAt
          ? `Sent ${new Date(r.sentAt).toLocaleString()}`
          : `Created ${new Date(r.createdAt).toLocaleDateString()}`}
      </p>
    ),
  },
];

const Campaigns = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { getModulePermission } = usePermissionEffect();
  const { data, isFetching } = useQuery(["email-campaigns", page], () =>
    getCampaigns(page),
  );

  return (
    <div className="w-full h-full pt-5 px-5 pb-40 space-y-6 font-dmsans">
      <div className="flex items-center justify-between">
        <div className="font-bold text-[22px] text-[#070E05]">Email campaigns</div>
        {getModulePermission("notification", "canCreate") && (
          <button
            type="button"
            onClick={() => navigate("/email-campaigns/new")}
            className="bg-dark text-white rounded-[5px] px-4 py-2 font-bold text-[14px]"
          >
            New campaign
          </button>
        )}
      </div>
      <div className="bg-white rounded-lg p-5">
        <Table
          rowKey="_id"
          loading={isFetching}
          dataSource={data?.campaigns || []}
          columns={columns}
          rowClassName="cursor-pointer hover:bg-gray-50"
          onRow={(r) => ({ onClick: () => navigate(`/email-campaigns/${r._id}`) })}
          pagination={{
            current: page,
            pageSize: 20,
            total: data?.total || 0,
            onChange: setPage,
          }}
        />
      </div>
    </div>
  );
};

export default Campaigns;
